import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bdc52b8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=2bdc52b8&prod&scoped=true&lang=stylus&"
import style1 from "./index.vue?vue&type=style&index=1&id=2bdc52b8&prod&module=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2bdc52b8",
  null
  
)

export default component.exports